import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 1679,
	height: 191,
	fill: "none",
	viewBox: "0 0 1600 191",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M293.499 52.46C186.267 30.736 60.729 32.002-1.771 37.002v154.479l1680.781 9.5V39.227c0-29.268 29.56-63.338-204.81-14.968-420.2 86.722-763.701 112.679-1180.701 28.2"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#e9f2fd",
		d: "M563 119.959c126.386 20.585 756.64 36.99 1116 44.001v-30.652c-41.17-.495-82.88-1.671-400.63-.483-397.181 1.484-635.267-4.829-715.37-12.866m-62.308-24.317C440.758 113.408 145.969 115.856-22 114.91l1.452-30.617c19.226.416 38.743.164 186.914 8.378 185.212 10.268 296.577 9.227 334.326 2.97"
	})]
});
export default SvgSnow;
